exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#ticker[data-v-4b7db8e2] {\n  text-align: left;\n  position: absolute;\n  border-style: solid;\n  color: #ffd500;\n  border-color: #ffd500;\n  opacity: 0.8;\n  border-width: 1px;\n  height: 1px;\n  overflow: visible;\n  z-index: 1002;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4b7db8e2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/Ticker.vue
// module id = 511
// module chunks = 0